import { render } from "./DashboardEditor.vue?vue&type=template&id=231a6730"
import script from "./DashboardEditor.vue?vue&type=script&lang=js"
export * from "./DashboardEditor.vue?vue&type=script&lang=js"
script.render = render

export default script